// @ts-nocheck

import { EllipsisOutlined } from '@ant-design/icons';
import React, { useRef } from 'react';
import Menu from 'antd/lib/menu';
import Button from 'antd/lib/button';
import { navigate } from '../../../lib/routerAdapter';

import { orderStatusEnum } from '../../../lib/enum';
import { Dropdown } from '../../../components/ui';

import CopyOrderButton from './CopyOrderButton';
import RedirectOrderButton from './RedirectOrderButton';
























/**
 * Компонент действий над заявкой в карточке заявки
 */
const OrderCardActionsDropdown = ({
  order,
  canApprove,
  canEdit,
  canRedirectOrder,
  canCopy,
  canCancel,
  canRestore,
  onCancel,
  onDelete,
  onRestore
}) => {
  const dropdown = useRef();
  const canEditOrder = canEdit && order.status !== orderStatusEnum.approved;
  const showDivider = canEditOrder || canRestore;

  return (
    <Dropdown
      ref={dropdown}
      overlay={
      <Menu>
          {order.vehicleId === null && canRedirectOrder ?
        <Menu.Item>
              <RedirectOrderButton order={order} />
            </Menu.Item> :
        null}
          {order.contractVehicleOrderId === null &&
        <Menu.Item
          onClick={() => {
            navigate(`/orders/${order.id}/contract-vehicle-order/new`);
          }}>

              Допнайм ТС
            </Menu.Item>
        }
          {canCopy &&
        <Menu.Item>
              <CopyOrderButton orderId={order.id} />
            </Menu.Item>
        }
          {canCancel &&
        <Menu.Item onClick={onCancel} data-test="orderCancel">
              Отменить заявку
            </Menu.Item>
        }
          {showDivider && <Menu.Divider />}
          {canEditOrder &&
        <Menu.Item onClick={() => navigate(`/orders/edit/${order.id}`)}>
              Редактировать
            </Menu.Item>
        }
          {canRestore &&
        <Menu.Item
          onClick={() => {
            onRestore();
            dropdown.current && dropdown.current.onVisibleChange(false);
          }}>

              Восстановить
            </Menu.Item>
        }
        </Menu>
      }>

      <Button className="openActionsDropdown" type="primary" icon={<EllipsisOutlined />} />
    </Dropdown>);

};

export default OrderCardActionsDropdown;